import React from "react";
import CountdownTimerComponent from "../CountdownTimer";
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

export default function CountdownTimer(props) {
  return (
    <>
      <Helmet>
        <title>Study Timer & Countdown Timer for Students | Student Tools Hub</title>
        <meta name="description" content="Free study timer and countdown timer for students. Boost focus with Pomodoro technique, track study sessions, and improve time management." />
        <meta name="keywords" content="study timer, pomodoro timer, countdown timer, time management, focus timer, productivity timer" />

        <meta property="og:title" content="Free Study Timer & Countdown Timer" />
        <meta property="og:description" content="Free study timer and countdown timer for students." />
        <meta property="og:url" content="https://student-tools-hub.vercel.app/timer" />
      </Helmet>

      <CountdownTimerComponent {...props} />
    </>
  );
}
